import React from 'react';
import { useNavigate } from 'react-router-dom';
import './HomePage.css';

const tools = [
  {
    id: 'sku-family-live',
    title: 'SKU Family Inventory',
    description: 'Project stock depletion per SKU family or color, live from Shopify — for Shipping Pilot, or per market (US / Europe) using that market\'s own locations and sales.',
    path: '/sku-family-live',
    badge: 'Inventory',
  },
  {
    id: 'inventory-management',
    title: 'Inventory Management',
    description: 'Pulls live inventory and 180-day net sales directly from Shopify to compute days remaining per SKU. One click — no file uploads needed.',
    path: '/inventory-management',
    badge: 'Shopify',
  },
  {
    id: 'draft-orders',
    title: 'Distributor Draft Orders',
    description: 'Upload PDF or Excel POs. Claude extracts line items, matches customers, creates Shopify draft orders, and sends a Slack notification for review.',
    path: '/draft-orders',
    badge: 'Orders',
  },
  {
    id: 'order-matrix',
    title: 'Order Matrix',
    description: 'Every product on one screen — product lines by colour, one cell per SKU, built live from Shopify. Save as many orders/counts as you like, copy into Google Sheets and paste results back.',
    path: '/order-matrix',
    badge: 'Orders',
  },
  {
    id: 'location-orders',
    title: 'Create Order by Location',
    description: 'Shopify\'s Create order, but per ship-from location: pick Shipping Pilot or Fanfinity BV first and only that location\'s stock shows. Invoices, payment terms, discounts and customers as usual. Also in the Shopify admin under Apps.',
    path: '/location-orders',
    badge: 'Orders',
  },
  {
    id: 'packiyo-ordering',
    title: 'Packiyo Ordering',
    description: 'Upload a convention order file (CSV or multi-sheet Excel). Select a Shopify location per order to generate a Packiyo order CSV and inventory update file.',
    path: '/packiyo-ordering',
    badge: 'Warehouse',
  },
  {
    id: 'eu-fulfillment',
    title: 'EU Fulfillment (Fanfinity)',
    description: 'Upload the weekly Fanfinity report once they confirm it has shipped. Matches each line to the order\'s open Fanfinity BV fulfillment and marks it fulfilled in Shopify, then posts a summary to Slack.',
    path: '/eu-fulfillment',
    badge: 'Orders',
  },
  {
    id: 'markitdown',
    title: 'PDF to Markdown',
    description: 'Upload PDFs and convert them to Markdown with MarkItDown. Converted files are downloadable for 30 days.',
    path: '/markitdown',
    badge: 'Utility',
  },
  {
    id: 'kpi-report',
    title: 'Distributor KPI Report',
    description: 'Pulls live Shopify order data for any date range and builds an Excel workbook with channel, product, sleeve, deckbox, color, geography, and AOV breakdowns for distributor/partner meetings.',
    path: '/kpi-report',
    badge: 'Reports',
  },
  {
    id: 'danger-zone',
    title: 'Danger-Zone Tools',
    description: 'Irreversible or high-impact tools, kept behind an extra click. Currently: Zero Out Location.',
    path: '/danger-zone',
    badge: 'Danger',
  },
  {
    id: 'wiki',
    title: 'Wiki',
    description: 'SOPs and documentation for these tools and anything else worth writing down.',
    path: '/wiki',
    badge: 'Docs',
  },
];

export default function HomePage() {
  const navigate = useNavigate();
  return (
    <div className="home">
      <h1>Tools</h1>
      <p className="home-sub">Select a tool to get started.</p>
      <div className="tool-grid">
        {tools.map(t => (
          <button key={t.id} className="tool-card" onClick={() => navigate(t.path)}>
            <span className="tool-badge">{t.badge}</span>
            <h2>{t.title}</h2>
            <p>{t.description}</p>
            <span className="tool-arrow">→</span>
          </button>
        ))}
      </div>
    </div>
  );
}
